var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CatalogForm',{attrs:{"type":'add',"save-action":_vm.createItemAction,"back":_vm.back,"error":_vm.error,"loading":_vm.loading,"saved":_vm.created}})
}
var staticRenderFns = []

export { render, staticRenderFns }